import { api } from '@/api/core';
import { CHAT_SHARE_CANDIDATES_TAG, LIST_QUERY_CACHE_TTL_SECONDS } from '@/api/constants';
import { GetChatShareCandidatesResponse } from './types';

interface DepartmentUserNode {
  id: string;
  name: string;
  email?: string;
}

const getChatShareCandidatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /** Users the current user can share a chat with (same department only). */
    getChatShareCandidates: builder.query<GetChatShareCandidatesResponse, void>({
      query: () => ({
        url: 'users/list-from-own-department',
        method: 'GET',
      }),
      transformResponse: (response: { users: DepartmentUserNode[] }) => ({
        candidates: response.users.map(({ id, name, email }) => ({ userId: id, name, email })),
      }),
      providesTags: () => [{ type: CHAT_SHARE_CANDIDATES_TAG }],
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useGetChatShareCandidatesQuery } = getChatShareCandidatesApi;
